import { motion } from "framer-motion";
import { Zap, Layers, Crosshair } from "lucide-react";
import { IMAGES } from "@/lib/api";

const benefits = [
  {
    icon: Zap,
    t: "Effortless productivity",
    d: "Your stylus is always docked and within reach \u2014 so signing, note-taking and quick edits never wait for you to hunt for a pen.",
  },
  {
    icon: Layers,
    t: "Sleek by design",
    d: "A flush recessed channel keeps the profile impossibly thin. Full MagSafe, zero bulk, no compromise on how it looks or feels.",
  },
  {
    icon: Crosshair,
    t: "Pro-grade accuracy",
    d: "An ultra-precise tip engineered for real work \u2014 annotate contracts, sketch concepts and mark up designs with pinpoint control.",
  },
];

export const Benefits = () => (
  <section data-testid="benefits-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-16 items-start">
      <div className="md:sticky md:top-28">
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-stone-500 mb-6">Built for pros on the move</p>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-tight text-stone-900">
          Do your best work <span className="italic">wherever you are.</span>
        </h2>
        <img
          src={IMAGES.lifestyle}
          alt="Professional working on the go"
          className="mt-10 w-full rounded-3xl object-cover aspect-[4/3] shadow-[0_24px_48px_rgba(0,0,0,0.06)]"
        />
      </div>
      <div className="space-y-4">
        {benefits.map((b, i) => (
          <motion.div
            key={b.t}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`benefit-card-${i}`}
            className="p-8 rounded-2xl bg-white border border-stone-200 hover:border-stone-300 transition-colors"
          >
            <b.icon className="w-6 h-6 mb-4 text-stone-800" strokeWidth={1.5} />
            <h3 className="text-xl font-bold text-stone-900 mb-2">{b.t}</h3>
            <p className="text-stone-600 leading-relaxed">{b.d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
